import type { RestoreWizardConfig } from '../types'

export const SETTINGS_WIZARD_CONFIG: RestoreWizardConfig = {
  kind: 'SETTINGS_POLICY',
  kindLabel: 'Settings & Policy Restore',
  unitIds: { select: 'settings-wz-1', repositories: 'settings-wz-2', targets: 'settings-wz-3', plan: 'settings-wz-4', order: 'settings-wz-5' },
  targetScopeForm: 'REPOSITORIES',
  singleRef: false,
}
